export default function useCheckedDate() {
  
    return (activeDate, serverDate, clientDate, computerDate)  =>{
        if (computerDate - clientDate >= activeDate - serverDate)
        return true
    else
        return false
   }
}